import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RtvCarHotListGrid } from '@bds/railtrac-models';
import { ApiReadService } from '@bds/odata';
import { RtvCarHotListGridApiServiceOptions } from './rtv-car-hot-list-grid.options';
import CustomStore from 'devextreme/data/custom_store';
import { LoadOptions } from 'devextreme/data';
import { BdsDxOdataParser } from '@bds/data-access';
import { IOdataCollectionResult } from '@bds/odata';
import { firstValueFrom, map } from 'rxjs';
import DataSource from 'devextreme/data/data_source';

@Injectable({
    providedIn: 'root',
})
export class RtvCarHotListGridService extends ApiReadService<RtvCarHotListGrid> {
    constructor(
        public options: RtvCarHotListGridApiServiceOptions,
        public http: HttpClient,
        private odataParser: BdsDxOdataParser,
    ) {
        super(options, http);
    }

    getHotlistDataGrid() {
        const store = new CustomStore({
            key: 'ormId',
            loadMode: 'processed',
            load: (loadOptions: LoadOptions) => {
                const queryString = this.odataParser.buildODataQueryString(loadOptions);
                return firstValueFrom(
                    this.http.post(`${this.options.odataUrl}`, queryString).pipe(
                        map((data: IOdataCollectionResult<RtvCarHotListGrid>) => {
                            return { totalCount: data['@odata.count'], data: data.value };
                        }),
                    ),
                );
            },
        });

        return new DataSource(store);
    }
}
